// extracted by mini-css-extract-plugin
export var list = "index-module--list--81Mwg";
export var listItem = "index-module--list-item--bmM0u";